import React from 'react';
import { SITE_CONFIG } from '../data/siteConfig';

export default function KakaoButton() {
  const { kakaoChannelId } = SITE_CONFIG;
  // 채널 미설정 시 동작 없는 버튼 노출 방지
  if (!kakaoChannelId) return null;
  const chatUrl = `https://pf.kakao.com/${kakaoChannelId}/chat`;

  return (
    <button
      type="button"
      aria-label="카카오톡 상담"
      onClick={() => window.open(chatUrl, '_blank', 'noopener,noreferrer')}
      style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 900,
        width: 56, height: 56, borderRadius: '50%',
        background: '#FEE500', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        fontSize: '0.8rem', fontWeight: 700,
        color: '#3C1E1E', transition: 'transform 0.2s',
        border: 'none', padding: 0, cursor: 'pointer',
      }}
      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
    >
      {/* KakaoTalk official logo shape */}
      <svg width="28" height="28" viewBox="0 0 24 24" fill="#3C1E1E">
        <path d="M12 3C6.48 3 2 6.36 2 10.44c0 2.61 1.74 4.9 4.36 6.2-.14.51-.9 3.28-.93 3.5 0 0-.02.16.08.22.1.06.22.01.22.01.29-.04 3.38-2.22 3.92-2.6.76.11 1.55.17 2.35.17 5.52 0 10-3.36 10-7.5S17.52 3 12 3z"/>
      </svg>
    </button>
  );
}
